import sortBy from 'lodash/sortBy';

export function sortColumns(columns) {
  return sortBy(columns, ['start', 'header']);
}
